import Color from '@arcgis/core/Color';
import WebmapColorBackground from '@arcgis/core/webmap/background/ColorBackground';

export const BackgroundColor = new WebmapColorBackground({
  color: new Color('#d4ebb5'),
});

export const BackgroundColorClass = 'bg-[#d4ebb5]';

export const BackgroundColorDark = new WebmapColorBackground({
  color: new Color('#d4ebb5'),
});

export const BackgroundColorDarkClass = 'bg-[#d4ebb5]';
